import * as React from "react";

// Matches Tailwind's `md` breakpoint, so JS layout decisions line up with
// `md:` classes.
const MOBILE_BREAKPOINT = 768;
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const getIsMobile = () =>
  typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches;

export function useIsMobile() {
  // Read synchronously on first render so callers that pick defaults on mount
  // (e.g. the calendar's initial view) see the right value immediately.
  const [isMobile, setIsMobile] = React.useState<boolean>(getIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
